import { Controller } from "@hotwired/stimulus"

import CommentForm from '../components/comment_form.svelte';
import ProtocolMeasurementsField from '../components/protocol_measurements_field.svelte';


// Connects to data-controller="svelte"
export default class extends Controller {
  static components = {
    CommentForm,
    ProtocolMeasurementsField
  }

  static values = {
    name: String,
    props: Object
  }

  connect() {
    if (!this.constructor.components[this.nameValue]) {
      console.error(`Svelte component ${this.nameValue} not found`);
      return;
    }

    new this.constructor.components[this.nameValue]({
      target: this.element,
      props: this.propsValue
    });
  }

  disconnect() {
    // Cleanup
    this.element.innerHTML = '';
  }
}
